import L from 'leaflet';
// import 'leaflet-routing-machine';

export const createMap = (ref, zoom, center) => {
    const map = L.map(ref).setView(center, zoom);
    L.tileLayer(process.env.REACT_APP_URL_MAPBOX, {
        attribution: 'CardioID'
    }).addTo(map);
    return map;
};

export const addRoute = (map, gpsPoints) => {
    if (!gpsPoints || gpsPoints.length === 0) return;
    const polyline = L.polyline(gpsPoints, { color: '#0A579B' }).addTo(map);
    map.fitBounds(polyline.getBounds());
    // L.Routing.control({
    //     waypoints: gpsPoints.map((point) => L.latLng(point[0], point[1])),
    //     routeWhileDragging: true,
    //     fitSelectedRoutes: true,
    //     draggableWaypoints: false,
    //     show: false,
    //     createMarker: () => null
    // }).addTo(map);
};
